<template>
  <el-dialog
    class="refund-detail"
    title="退款记录"
    :visible.sync="showDetailDialog"
    width="860px"
  >
    <div class="refund-item" v-for="item in list" :key="item.refund_num">
      <div class="refund-number">
        <span>退款单编号：{{ item.refund_num }}</span>
        <span class="refund-status" :class="'refund-status-' + item.status">
          {{ item.status | enum("OrderRefundStatus") }}
        </span>
      </div>
      <div class="refund-shops">
        <div
          v-for="shop in item.items"
          :key="shop.id"
          class="refund-line refund-shop"
        >
          <span>{{ shop.shop_name }}</span>
          <span class="refund-shop_number">x {{ shop.refund_num }}</span>
        </div>
      </div>
      <div class="refund-line refund-time">
        <span>退款申请时间：{{ item.created_at | tsFormatLong }}</span>
        <span v-if="order.order_type!=8">申请退款金额：{{ item.refund_price / 100 }}元</span>
      </div>
      <div class="refund-line">申请退款原因：{{ item.reason }}</div>
      <div v-if="item.status == 5">驳回原因：{{ item.remark }}</div>
      <template
        v-else-if="item.status == 2 || item.status == 4 || item.status == 6"
      >
        <div v-if="item.status == 2" class="refund-back refund-line">
          <span>实际退款时间：{{ item.updated_at | tsFormatLong }}</span>
          <span>实际退款金额：{{ item.send_back_fee / 100 }}元</span>
        </div>
        <div v-else class="refund-back refund-line">
          <span>实际退款时间：-</span>
          <span>实际退款金额：-</span>
        </div>
        <div class="refund-line">备注：{{ item.remark }}</div>
      </template>
      <div class="refund-line" v-else-if="item.status == 3">
        取消申请时间：{{ item.updated_at | tsFormatLong }}
      </div>
    </div>
    <div class="refund-footer">
      <el-button
        class="refund-button"
        type="danger"
        @click="showDetailDialog = false"
      >
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "MemberOrderRefundDetail",
  data() {
    return {
      showDetailDialog: false,
      order: {},
      list: [],
    };
  },
  methods: {
    async show(order) {
      this.order = order;
      this.showDetailDialog = true;
      this.list = await this.$http.get(
        "/api/app/myOrder/refundDetail/" + order.order_number,
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.refund-detail {
  /deep/ {
    .el-dialog {
      padding: 22px 24px;
    }
    .el-dialog__header {
      padding: 0;
      margin-bottom: 22px;
    }
    .el-dialog__headerbtn {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
}
.refund-item {
  border: 1px solid #cdcdcd;
  border-radius: 4px;
  padding: 14px 16px 12px 16px;
  font-size: 14px;
  color: #333;
  margin-bottom: 20px;

  &:nth-last-child(2) {
    margin-bottom: 0;
  }
}
.refund-number {
  display: flex;
  justify-content: space-between;
  color: #666666;
  padding-bottom: 14px;
  border-bottom: 1px solid #e6e6e6;
}
.refund-shops {
  padding: 12px 0;
  border-bottom: 1px solid #e6e6e6;
  margin-bottom: 12px;
}
.refund-line {
  line-height: 30px;
}
.refund-time,
.refund-back,
.refund-shop {
  display: flex;
  justify-content: space-between;
}
.refund-shop_number {
  color: #666;
}
.refund-status-2 {
  color: #11cc59;
}
.refund-status-4,
.refund-status-5 {
  color: #ff2424;
}
.refund-status-6 {
  color: #bb1c20;
}
.refund-footer {
  text-align: right;
  padding-top: 22px;
}
.refund-button {
  background-color: #bb1c20;
  padding: 12px 19px;
  border-radius: 3px;
}
</style>
